import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

interface StateProps {
    isLoading: boolean;
    lastRunCreditsCharged?: number;
}

const initialState: StateProps = {
    isLoading: false,
};

export const emailMakerAiRedesignPromptBoxSlice = createSlice({
    name: 'emailMakerAiRedesignPromptBox',
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setLastRunCreditsCharged: (state, action: PayloadAction<number | undefined>) => {
            state.lastRunCreditsCharged = action.payload;
        },
    }
})

export const {setIsLoading, setLastRunCreditsCharged} = emailMakerAiRedesignPromptBoxSlice.actions;

export const emailMakerAiRedesignPromptBoxReducer = emailMakerAiRedesignPromptBoxSlice.reducer;